import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  isSaveStatusButtonDisabledState,
  appointmentStatusState,
  statusModalOpenState,
  selectedUserState
} from "store/appointment/atoms/appointmentAtomState";
import {
  focusRing,
  ghostBtn,
  primaryBtn,
  select as selectCls,
} from "components/ui/instrument";

const appointmentStatusSelectOptions = [
  { name: "Choose a status", value: null },
  { name: "Created", value: "created" },
  { name: "Scheduled", value: "scheduled" },
  { name: "Pending Confirmation", value: "pending_confirmation" },
  { name: "On Going", value: "on_going" },
  { name: "Consultation Done", value: "consultation_done" },
  { name: "Cancelled", value: "cancelled" },
  { name: "Closed", value: "closed" },
];
interface AppointmentStatusModalProps {
  handleStatusChangeSaveClick: () => void;
}

function AppointmentStatusModal({
  handleStatusChangeSaveClick,
}: AppointmentStatusModalProps) {
  const [appointmentStatus, setAppointmentStatus] = useRecoilState(
    appointmentStatusState
  );
  const [selectedUser, setSelectedUser] = useRecoilState(selectedUserState);
  const [isStatusModalOpen, setIsStatusModalOpen] =
    useRecoilState(statusModalOpenState);
  const isSaveStatusButtonDisabled = useRecoilValue(
    isSaveStatusButtonDisabledState
  );

  return (
    <>
      {" "}
      {isStatusModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="modal-overlay absolute h-full w-full bg-clinic-900 opacity-50"></div>
          <div className="modal-container z-50 mx-auto w-96 rounded-lg border border-clinic-200 bg-white shadow-lg">
            <div className="modal-content p-6">
              <button
                className={`relative left-[330px] rounded text-clinic-400 hover:text-clinic-600 ${focusRing}`}
                onClick={() => setIsStatusModalOpen(false)}
                aria-label="Close"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <h2 className="mb-4 text-base font-bold text-clinic-900">Change Status</h2>
              {selectedUser.scheduled_at===null && <p className="text-warn-600 pb-2 font-semibold">Please Select an Appointment Date to Enable Other Options</p>}
              <select
                value={appointmentStatus}
                onChange={(e) => setAppointmentStatus(e.target.value)}
                className={`w-full ${selectCls}`}
              >
                {appointmentStatusSelectOptions.map((status, index) => (
                  <option key={index} value={status.value as string} disabled={selectedUser.scheduled_at===null && status.value!=="cancelled"}>
                    {status.name}
                  </option>
                ))}
              </select>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleStatusChangeSaveClick}
                  className={primaryBtn}
                  disabled={isSaveStatusButtonDisabled}
                >
                  {isSaveStatusButtonDisabled ? "Please Wait" : "Save"}
                </button>

                <button
                  className={`ml-2 ${ghostBtn}`}
                  onClick={() => setIsStatusModalOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AppointmentStatusModal;
